/**
 * Cart drawer delivery messaging from validated PIN in localStorage.
 */
import { getStoredPin, isDelhiNcrPin } from '@theme/ffp-delivery-checker';
import { getCutoffStatus } from '@theme/ffp-cutoff-countdown';
import { StandardEvents } from '@shopify/events';

export { getStoredPin };

/**
 * @param {HTMLElement} container
 */
export function renderDeliveryBanner(container) {
  const pin = getStoredPin();
  const cutoff = getCutoffStatus();
  const valid = pin ? isDelhiNcrPin(pin) : false;

  let message;
  let state = 'neutral';
  let tag = '';

  if (valid) {
    state = 'success';
    tag = 'Next-day delivery';
    message = `${cutoff.message} · PIN ${pin}`;
  } else if (pin && pin.length === 6) {
    state = 'warning';
    message = 'Outside Delhi NCR — message us on WhatsApp for special requests';
  } else {
    state = 'neutral';
    message = 'Enter your PIN in the header to confirm next-day Delhi NCR delivery';
  }

  container.dataset.state = state;
  container.innerHTML = `
    ${tag ? `<span class="ffp-cart-delivery__tag">${tag}</span>` : ''}
    <p class="ffp-cart-delivery__text">${message}</p>
    <a class="ffp-cart-delivery__upsell" href="/#customize-bouquet?addon=chocolates">Add chocolates (+₹300)</a>
  `;
}

class FfpCartDeliveryBanner extends HTMLElement {
  connectedCallback() {
    renderDeliveryBanner(this);
    document.addEventListener('ffp:pin-updated', this.#render);
    document.addEventListener(StandardEvents.cartLinesUpdate, this.#render);
  }

  disconnectedCallback() {
    document.removeEventListener('ffp:pin-updated', this.#render);
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.#render);
  }

  #render = () => {
    renderDeliveryBanner(this);
  };
}

if (!customElements.get('ffp-cart-delivery-banner')) {
  customElements.define('ffp-cart-delivery-banner', FfpCartDeliveryBanner);
}
